import { useDigitalAssets } from 'modules/tt-digital-assets-provider';
import React, { useState } from 'react';
import {
  Modal,
  Space,
  InputTextArea,
  Button,
  Loader,
  openNotification,
  CodeView,
} from 'tt-ui-lib/core';

const SignMessageWalletModal = ({ open, setOpen }) => {
  const { web3 } = useDigitalAssets();

  const [message, setMessage] = useState('');
  const [signature, setSignature] = useState('');
  const [messageHash, setMessageHash] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setOpen(false);
    setMessage('');
    setSignature('');
  };

  const handleSign = () => {
    if (!message) {
      openNotification({
        type: 'info',
        message: 'Please enter a message to sign',
      });
      return;
    }

    setLoading(true);

    if (!web3 || !web3.eth) {
      openNotification({
        type: 'error',
        message: 'Web3 is not initialized',
      });
      setLoading(false);
      return;
    }

    try {
      web3.eth
        .getAccounts()
        .then((accounts) => {
          if (!accounts || accounts.length === 0) {
            throw new Error('No available accounts');
          }

          const account = accounts[0];

          const msgHash = web3.utils.sha3(message);
          setMessageHash(msgHash || '-');

          return web3.eth.personal.sign(message, account, '');
        })
        .then((signedMessage) => {
          setSignature(signedMessage || '-');
        })
        .catch((error) => {
          console.error('Error:', error);
          openNotification({
            type: 'error',
            message: `Error: ${error.message || 'Unknown error'}`,
          });
        })
        .finally(() => setLoading(false));
    } catch (error) {
      console.error('Error:', error);
      openNotification({
        type: 'error',
        message: `Error: ${error.message || 'Unknown error'}`,
      });
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onCancel={handleCancel} title="Sign message with wallet" closeOnlyByControls>
      <Space direction="vertical" style={{ width: '100%' }}>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              width: '100%',
            }}
          >
            <Loader />
          </div>
        ) : signature ? (
          <Space direction="vertical" style={{ width: '100%' }}>
            <CodeView
              code={{
                messageHash,
                signature,
              }}
              style={{ width: '100%', maxWidth: '100%', breakWord: 'break-all' }}
            />

            <Button
              type="default"
              onClick={() => {
                setMessage('');
                setSignature('');
                setMessageHash('');
              }}
              style={{ marginTop: '10px' }}
            >
              Back
            </Button>
          </Space>
        ) : (
          <>
            <div style={{ width: '100%', marginTop: '5px', marginBottom: '15px' }}>
              <InputTextArea
                label="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <Space
              direction="horizontal"
              style={{ width: '100%', justifyContent: 'space-between' }}
            >
              <Button type="default" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" onClick={handleSign} disabled={!message}>
                Sign
              </Button>
            </Space>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default SignMessageWalletModal;
